// import React from 'react';
// import { createRoot } from 'react-dom/client';
// import { Provider } from 'react-redux';

const modules = [
  // React Modules
  // {
  //   name: 'ShopAccessories',
  //   loader: () => import('./modules/react/shop-accessories/ShopAccessoriesRoot.js'),
  //   async render(Root, el) {
  //     const store = await import('./modules/react/shop-accessories/store/index.js');
  //     createRoot(el[0]).render(<Provider store={store.store}><Root rootElement={el[0]} /></Provider>);
  //   },
  // },
  // JS Modules
  {
    name: 'Typography',
    loader: () => import('./Typography'),
    inline: false, // Set to true to bundle with app.bundle.js instead of separate chunk
  },
  {
    name: 'FormAnimation',
    loader: () => import('../../../modules/form-module/script.js'),
    inline: false,
  },
  {
    name: 'SelectC8',
    loader: () => import('../5-libs/SelectC8'),
    inline: false,
  },
  {
    name: 'Tabs',
    loader: () => import('../../../modules/tabs/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'Accordion',
    loader: () => import('../../../modules/accordion/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ModSlider',
    loader: () => import('../../../modules/slider/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'ModCarouselSlide',
    loader: () => import('../../../modules/slider-ada/script.js'),
    inline: false,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },
  {
    name: 'BasicModule',
    loader: () => import('../../../modules/basic/script.js'),
    inline: true,
    render(ModuleClass, elements) {
      elements.forEach((el) => {
        const instance = new ModuleClass(el);
        instance.init();
      });
    },
  },

];

export default [...modules];
